import { useRef, useEffect } from 'react';

export const usePrevious = (value: any, initialValue?: any): any => {
  const ref = useRef<string | number>(initialValue);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
